import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=4355b15a&scoped=true"
import script from "./Pagination.ts?vue&type=script&lang=ts&external"
export * from "./Pagination.ts?vue&type=script&lang=ts&external"
import style0 from "./Pagination.scss?vue&type=style&index=0&id=4355b15a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4355b15a",
  null
  
)

export default component.exports